angular
	.module 'App.Repository'
	.factory 'ProductVariantTranslationRepository', [
		'BaseRepository',
		(BaseRepository) ->
			class ProductVariantTranslationRepository extends BaseRepository
				@resource = '/product_variant_translations'
				@isRestricted = true

			return new ProductVariantTranslationRepository
	]
